import http from "../httpService";
import {getBaseUrl} from "../../config";

export const getAgentSchedules = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_schedule`,
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_schedule?${paginate}`,
  );
};

export const getAgentMonthSchedule = (jy, jm, monthDays) => {
  return http.get(
    `${getBaseUrl()}/agent_month_schedule/${jy}/${jm}/${monthDays}`,
  );
};

//
export const updateSchedule = data => {

  return http.put(
    `${getBaseUrl()}/schedule/${data.id}`,
    data
  );
};

export const submitSchedule = data => {

  return http.post(
    `${getBaseUrl()}/schedule`,
    data
  );
};
